export function parseLinkToolToMarkdown(data) {
  return `[${data.link}|${data.link}|smart-card]\n`;
}
